import React from 'react'

const NoPage = () => {
  return (
    <div>
      <h1>NO PAge</h1>
    </div>
  )
}

export default NoPage
